import Reveal from "./Reveal";
import { LogoMark } from "./LogoMark";

const Footer = () => (
  <footer data-testid="footer-section" className="bg-[#09090B] text-[#FAF9F6] pt-20 pb-8 overflow-hidden">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <Reveal>
        <h2
          data-testid="footer-brand"
          className="font-display font-extrabold tracking-tight leading-none text-[18vw] lg:text-[13rem] text-white/[0.07] select-none text-center"
          aria-hidden="true"
        >
          VOICXENT
        </h2>
      </Reveal>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-10 mt-4 border-t border-white/10 pt-12">
        <div className="col-span-2 md:col-span-1">
          <div className="flex items-center gap-2.5">
            <LogoMark size={26} />
            <span className="font-display font-extrabold">Voicxent</span>
          </div>
          <p className="text-zinc-500 text-sm mt-4 leading-relaxed">
            Voice agents that answer, remind, and follow up — for any business.
          </p>
          <p className="flex items-center gap-2 mt-5 text-xs text-zinc-500">
            <span className="w-2 h-2 rounded-full bg-[#16A34A] blink-dot" />
            Collections pack live
          </p>
        </div>
        {[
          {
            h: "Platform",
            links: [
              ["Use cases", "#use-cases"],
              ["Collections pack", "#collections"],
              ["How it works", "#how-it-works"],
            ],
          },
          {
            h: "Trust",
            links: [
              ["Security", "#security"],
              ["What it cannot do", "#honest-list"],
              ["FAQ", "#faq"],
            ],
          },
          {
            h: "Start",
            links: [
              ["Book a demo", "#contact"],
              ["Get started", "#get-started"],
            ],
          },
        ].map((col) => (
          <div key={col.h}>
            <p className="font-mono2 text-[10px] uppercase tracking-[0.28em] text-zinc-500">{col.h}</p>
            <ul className="mt-5 space-y-3">
              {col.links.map(([label, href]) => (
                <li key={label}>
                  <a
                    data-testid={`footer-link-${label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                    href={href}
                    onClick={(e) => {
                      e.preventDefault();
                      document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
                    }}
                    className="text-sm text-zinc-400 hover:text-white transition-colors duration-300"
                  >
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="flex flex-col sm:flex-row items-center justify-between gap-4 mt-14 pt-6 border-t border-white/10">
        <p className="text-xs text-zinc-600">© {new Date().getFullYear()} Voicxent. All rights reserved.</p>
        <p className="font-mono2 text-[10px] uppercase tracking-widest text-zinc-600">Hindi · English · বাংলা</p>
      </div>
    </div>
  </footer>
);

export default Footer;
